<script>
   /**************************************************************/
   /* ResultsTable                                               */
   /* -------------------------                                  */
   /* shows table with SIMCA results for test set                */
   /**************************************************************/

   // main properties of the whole app
   let { res, ncomp } = $props();

   // a stranger set the distribution can not be fitted to has no selectivity
   const fmt = (v) => Number.isFinite(v) ? v.toFixed(3) : '-';
</script>


{#if res}
<table>
   <thead>
   <tr>
      <th></th>
      <th>Test</th>
   </tr>
   </thead>
   <tbody>
   <tr>
      <td class="label">Members</td>
      <td>{res.nMembers}</td>
   </tr>
   {#if res.nMembers > 0}
   <tr>
      <td class="label">Out</td>
      <td>{res.v[ncomp - 1].rolsNum.outlier + res.v[ncomp - 1].rolsNum.extreme}</td>
   </tr>
   <tr>
      <td class="label">Sensitivity</td>
      <td>{fmt(res.stat.sensitivity[ncomp - 1])}</td>
   </tr>
   {/if}

   <tr class="section">
      <td class="label">Strangers</td>
      <td>{res.nStrangers}</td>
   </tr>

   {#if res.nStrangers > 0}
   <tr>
      <td class="label">In</td>
      <td>{res.v[ncomp - 1].decsNum.in - res.v[ncomp - 1].rolsNum.regular}</td>
   </tr>
   <tr>
      <td class="label">Specificity</td>
      <td>{fmt(res.stat.specificity[ncomp - 1])}</td>
   </tr>
   <tr>
      <td class="label">Selectivity</td>
      <td>{fmt(res.stat.selectivity[ncomp - 1])}</td>
   </tr>
   {/if}

   {#if res.nStrangers > 0 && res.nMembers > 0}
   <tr>
      <td class="label">Efficiency</td>
      <td>{fmt(res.stat.efficiency[ncomp - 1])}</td>
   </tr>
   {/if}

   </tbody>
</table>
{/if}

<style>
   table {
      width: 100%;
      border-collapse: collapse;
   }

   tr {
      width: 100%;
   }

   th {
      border-bottom: 1px solid #a0a0a0;
   }

   tr.section > td {
      border-top: 1px solid #a0a0a0;
   }

   th, td {
      text-align: right;
      padding: 0.2em 0.5em 0.2em 0.1em;
      color: #404040;
      margin: 0;
   }

   .label {
      text-align: left;
      padding: 0.1em 0.5em;
   }
</style>